import React, {Component, Fragment} from 'react';
import {observer,inject} from "mobx-react";
import {StoreContext} from "../../stores/contexts";

class Options extends Component {
  static contextType = StoreContext;

  render() {
    return (
      <div className="pa pa-tr z3 tal unlimitedFilterLayoutEditor" style={{right:-44}}>
        {!this.context.configStore.layout_editor?(
            <span className="btn6 withIcon iconOnly" onClick={()=>{
              this.context.configStore.layout_editor=!this.context.configStore.layout_editor;
            }}><span><i className="mdi mdi-cog"></i></span></span>
          ):(
            <>
              <div>
                <span className="btn6 withIcon iconOnly" onClick={()=>{
                  this.context.configStore.saveLayout();
                }}><span><i className="mdi mdi-check sc1"></i></span></span>
              </div>
              <div>
                <span className="btn6 withIcon iconOnly" onClick={()=>{
                  this.context.configStore.saveLayout(true);
                }}><span><i className="mdi mdi-check-all"></i></span></span>
              </div>
              <div>
                <span className="btn6 withIcon iconOnly" onClick={()=>{
                  this.context.configStore.layout_editor=!this.context.configStore.layout_editor;
                }}><span><i className="mdi mdi-close"></i></span></span>
              </div>
            </>
          )}
          {this.context.configStore.config.data.export_route?(
            <div>
              <span className="btn6 withIcon iconOnly" onClick={()=>{
                this.context.dataStore.initExport();
              }}><span><i className="mdi mdi-export-variant"></i></span></span>
            </div>
          ):null}

      </div>
    )
  }
}

// export default inject("configStore",)(observer(Options));
export default observer(Options);